import Router from "next/router";
import { getUrlParams } from "lib/utils/getUrlParams";
import { ExperimentsListContent } from "types/graphql/generated";

/**
 * Setup experiments based on the provided experiments list.
 * @param experimentsList - The list of experiments to run.
 * @returns A boolean indicating whether any experiment was successfully run.
 */
export const setupExperiments = (experimentsList?: ExperimentsListContent[]): boolean => {
  const state = window?.optimizely?.get("state");

  const experiments = state?.getExperimentStates();

  if (!experiments || !experimentsList) return false;

  for (const item of experimentsList) {
    if (!item.enabled) {
      continue;
    }

    const experiment = experiments[item.experiment_id];

    const variantId = experiment?.variation?.id;

    const isActive = experiment?.isActive;

    const isVariation = variantId === item.variant_id;

    if (isActive && isVariation) {
      return runActions(item);
    }
  }

  return false;
};

/**
 * Runs the actions specified in the given `ExperimentsListContent` item.
 * @param item - The item containing the actions to be executed.
 * @returns `true` if the actions were successfully executed, `false` otherwise.
 */
export const runActions = (item: ExperimentsListContent): boolean => {
  if (!item) return false;

  switch (item.type) {
    case "redirect": {
      if (!window.location) return false;

      const params = getUrlParams(window.location.search);

      if (!item.url) {
        console.error("No url provided for redirect action");

        return false;
      }

      Router.replace(`${item.url}${params}`);

      return true;
    }

    default:
      return false;
  }
};
